import useDoExerciseStore from "../../store/exerciseStore"
import { useEffect } from "react";
import { cn } from "../../lib/utils";
import { useState } from "react";
import TextToSpeech from "./TextToSpeech";
import SpeechToText from "./SpeechToText";
import { Feedback } from "./FeeadBack";
import { Writing } from "./Writting";
import useDoTestStore from "../../store/testStore";

export default function Question({question,index,answer,isTest=false}) {


  const { addAnswer,isDirty, isLoading } = useDoExerciseStore()
  const { addAnswerTest} = useDoTestStore()
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDirty) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isDirty]);

  const [optionSelected, setOptionSelected] = useState(null)

  const handleAnswer = (answer) => {
    setOptionSelected(answer)
    isTest ?
    addAnswerTest({
      answer,
      question_id: question.question_id
    })
    :
    addAnswer({
      answer,
      question_id: question.question_id
    })
  }
  return (
     <div>

          <div className={cn(
            "flex flex-row flex-wrap gap-2",
            answer && answer==optionSelected  ? "text-green-500" : "",
            answer && answer!==optionSelected ? "text-red-500" : "",
            // answer && !answer.answer ? "text-blue-500" : "",
            )}>
            <div>
            <h2 className="text-xl font-semibold">{index+1}/ {question.details.question}</h2>

            {
              // Nghe
            question.details.audio
            &&
            <TextToSpeech text={question.details.audio}/>
            }
            </div>
          </div>
          {
            question.type === 1 ?
            <input
            className="w-full border-0 border-b-2 border-gray-400 focus:border-red-500 focus:outline-none p-2 transition-all"
            type="text"
            name="answer"
            id="answer"
            placeholder="Your answer..."
            onChange={(e) => handleAnswer(e.target.value)}
          />
            :
            question.type === 2 ?
              question.details.options.map((option) => (
              <div className="flex flex-row items-center gap-1">
                <input
                name={`answer-${question.id}`}
                type="radio"
                value={option}
                onClick={(e) => handleAnswer(e.target.value)}
                disabled={!!answer}
                className={cn("cursor-pointer accent-red-500"
                )}/>
                <div className={cn( answer===option ? "text-green-400 font-black" : "")}>
                {option}
                </div>

              </div>
            ))
            :
            question.type === 3 ?
            <Writing onChange={handleAnswer}/>

            :
            question.type === 4 ?
            <SpeechToText question_id={question.question_id}/>
            :
            null
          }

          {
            (answer && answer.comment)
            ?
            <Feedback feedback={answer.comment}/>

            : null
          }

      </div>
  )
}
